
















import { Component, Prop, Vue } from 'vue-property-decorator';

import { VatDashboard } from './models/vat-dashboard';
import { Vat } from '@/api';
import VatChartAdmin from '@/components/charts/vat-chart-admin.vue';
import VatCurrentStatus from '@/components/charts/vat-currentStatus.vue';
@Component({
	components: {
		VatChartAdmin,
		VatCurrentStatus,
	},
})
export default class MilkVatChartsTab extends Vue {
	@Prop({ required: true, type: Object })
	public readonly vat!: Vat;

	@Prop({ required: true, type: Object })
	public readonly dashboardData!: VatDashboard;
}
